import { createTheme as o } from "../../_mixins/use-theme.js";
import i from "../../_styles/common/light.js";
import t from "../../tooltip/styles/light.js";
const m = o({
  name: "Ellipsis",
  common: i,
  peers: {
    Tooltip: t
  }
}), l = m;
export {
  l as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/ellipsis/styles/light.js
// module id = 916
// module chunks = 41